"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FeatureFlagsDto {
}
exports.FeatureFlagsDto = FeatureFlagsDto;
class SystemConfigurationFlags {
}
exports.SystemConfigurationFlags = SystemConfigurationFlags;
class CurrentFacilityFeatureFlags {
}
exports.CurrentFacilityFeatureFlags = CurrentFacilityFeatureFlags;
